import { FC, useState, useCallback } from 'react'
import styles from 'components/features/socialFeed/ComposeActions/ComposeActions.styl'
import EmojiSvg from 'icons/emoji.svg'
import SvgIcon from 'components/atoms/SvgIcon'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'
import EmojiPicker from 'components/features/pfm/EmojiPicker/EmojiPicker'
import { WithComposeId } from 'interfaces/feed'
import { OuterEvent } from 'components/features/pfm/OuterEvent/OuterEvent'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { composeExecCommandActionCreator } from 'actions/feedComposeActions'

type AddEmojiButtonProps =
  & WithComposeId

export const AddEmojiButton: FC<AddEmojiButtonProps> = ({
  composeId,
}) => {
  const [isEmojiShown, setIsEmojiShown] = useState(false)
  const dispatch = useStoreDispatch()

  const handleShow = useCallback(() => {
    setIsEmojiShown(true)
  }, [setIsEmojiShown])

  const handleHide = useCallback(() => {
    if (!isEmojiShown) {
      return
    }

    setIsEmojiShown(false)

    dispatch(composeExecCommandActionCreator({
      composeId,
      command: {
        type: 'focus',
      },
    }))
  }, [composeId, dispatch, isEmojiShown])

  const handleEmojiSelect = useCallback<(emoji: string) => void>((emoji) => {
    dispatch(composeExecCommandActionCreator({
      composeId,
      command: {
        type: 'insertText',
        text: emoji,
      },
    }))
    setIsEmojiShown(false)
  }, [composeId, dispatch])

  return (
    <div className={ styles.action }>
      <AnalyticsClick
        category='module-feed_compose'
        action='click-add_emoji'
      >
        <button className={ styles.actionContent } onClick={ handleShow }>
          <div className={ styles.actionIcon }>
            <SvgIcon src={ EmojiSvg } />
          </div>
          Emoji
        </button>
        <OuterEvent
          className={ styles.emojiPicker }
          onOuterClick={ handleHide }
          onOuterESC={ handleHide }
        >
          { isEmojiShown && <EmojiPicker onSelect={ handleEmojiSelect } /> }
        </OuterEvent>
      </AnalyticsClick>
    </div>
  )
}
